<template>
    <div class="flex flex-row">
        <div class="grow pr-2">
            <input
                id="attachment-file-upload"
                type="file"
                class="hidden transition-all"
                accept="application/xml"
                autocomplete="off"
                @change="uploadFileWithFilePicker"
            >
            <label
                for="attachment-file-upload"
                style="cursor: pointer"
                class="p-2 cursor-pointer border border-secondary border-dashed bg-secondary/10 text-secondary font-bold
          transition-all rounded text-center flex items-center h-full"
                :class="file ? 'flex-row': 'flex-col'"
                @dragover.prevent
                @drop.prevent="onDrop"
            >
                <span class="flex items-center h-full">
                    <i class="i-mdi-paperclip-plus text-[2rem] mr-4 transition-all" :class="file ? 'text-[1rem]': ''"/>
                    <span v-if="!file" class="xl:md">
                        {{ $t('saft.upload') }}
                    </span>
                </span>
                <span v-if="file">
                    <i
                        class="i-mdi-close text-error hover:text-red-500 pointer-cursor"
                        @click.stop.prevent="removeFile"
                    />
                    <span class="flex items-center">
                        <i
                            class="mr-1"
                            :class="resolveFileIcon(file.name)"
                        />
                        <span class="">{{ file.name }}</span>
                    </span>
                </span>
            </label>
        </div>
        <UButton :disabled="!file" @click="uploadSaftExport">{{ $t('saft.import').toUpperCase() }}</UButton>
    </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'
import { resolveFileIcon } from '@/services/document.service'
import { importSaftExport } from '@/services/saft.service'

const file = ref()


const onDrop = (e: Event) => {
    const target = e.target as HTMLInputElement
    if (target.files && target.files.length > 0) file.value = target.files[0]
}

const uploadFileWithFilePicker = (e: Event) => {
    const target = e.target as HTMLInputElement
    if (target.files && target.files.length > 0) file.value = target.files[0]
}

const removeFile = () => {
    file.value = null
}

const uploadSaftExport = async () => {
    await importSaftExport(file.value)
    removeFile()
    window.location.reload()
}

</script>

<style scoped>

</style>